import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LocalizationModule } from '@nimbus-library/features/localization/localization.module';
import { NimbusMaterialButtonModule } from '@nimbus-library/features/shared/components/material/buttons/nimbus-material-button.module';
import { MatDurationPickerComponent } from '@nimbus-library/features/shared/components/material/mat-time/mat-duration-picker/mat-duration-picker.component';
import { MatMeridianDirective } from '@nimbus-library/features/shared/components/material/mat-time/mat-meridian/mat-meridian.directive';
import { MatTimeNumberDirective } from './mat-time-number/mat-time-number.directive';
import { MatTimePickerComponent } from './mat-time-picker/mat-time-picker.component';

@NgModule({
  imports: [A11yModule, CommonModule, OverlayModule, FormsModule, NimbusMaterialButtonModule, LocalizationModule],
  exports: [MatFormFieldModule, MatTimePickerComponent, MatDurationPickerComponent, MatTimeNumberDirective, MatMeridianDirective],
  declarations: [MatTimePickerComponent, MatDurationPickerComponent, MatTimeNumberDirective, MatMeridianDirective],
})
export class MatTimeModule {}
